import Vue from 'vue'
//import Cookie from 'vue-cookie'
//Vue.use(Cookie)

export default {
    changeValorContribuicaoHome(context, payload){
        context.commit('SET_VALOR_CONTRIBUICAO_HOME', payload)
    },
    changeUser(context, payload){
        context.commit('SET_USER', payload)
    },
    changeAuth(context, payload){
        context.commit('SET_AUTH', payload)
    },
    changeCartaoVigente(context, payload){
        context.commit('SET_CARTAO_VIGENTE', payload)
    },
    changeConfirmacaoPagamento(context, payload){
        context.commit('SET_CONFIRMACAO_PAGAMENTO', payload)
    },
    changeCarrinho(context, payload){
        context.commit('SET_CARRINHO', payload)
        localStorage.setItem('carrinho', JSON.stringify(context.getters.getCarrinho))
        //Vue.cookie.set('carrinho', JSON.stringify(context.getters.getCarrinho), 1)
    },
    addCarrinho(context, payload){
        context.commit('ADD_CARRINHO', payload)
        localStorage.setItem('carrinho', JSON.stringify(context.getters.getCarrinho))
        //Vue.cookie.set('carrinho', JSON.stringify(context.getters.getCarrinho), 1)
    },
    removeFromCarrinho(context, index){
        context.commit('REMOVE_CARRINHO', index)
        localStorage.setItem('carrinho', JSON.stringify(context.getters.getCarrinho))
        //Vue.cookie.set('carrinho', JSON.stringify(context.getters.getCarrinho), 1)
    },
    changeMenu(context, payload){
        context.commit('SET_MENU', payload)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js